export default __webpack_public_path__ + "static/media/table.6f850d29.png";